import { gql } from "@apollo/client"

export const MULTI_PROMO = gql`
  query getMultiPromo($slug: String!, $branchName: String) {
    getMultiPromo(slug: $slug, branchName: $branchName) {
      productSku
      experimentId
      landingPageUrl
      pdpUrl
    }
  }
`
